import { render } from "./OpmPage.vue?vue&type=template&id=1f51f4e9&scoped=true"
import script from "./OpmPage.vue?vue&type=script&lang=js"
export * from "./OpmPage.vue?vue&type=script&lang=js"

import "./OpmPage.vue?vue&type=style&index=0&id=1f51f4e9&scoped=true&lang=css"

import exportComponent from "/Users/apple/Projects/opm/yuzhangmen/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f51f4e9"]])

export default __exports__